module.exports = __webpack_public_path__ + "img/LOGO.3f826138.png";